import React from 'react';
import DashboardMapCard from '../DashboardMapCard';

// Map view simply embeds the existing modernized map card. The cockpit
// frame already provides the surrounding panel chrome, so the inner card
// fills its container.
export default function CanvasMap({ onPointClick }) {
  return (
    <div className="h-full">
      <DashboardMapCard onPointClick={onPointClick} />
    </div>
  );
}
